// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCxA2jYraO1nLz3mdjjasDFBPhnsJ47j1E",
  authDomain: "theta-b3cb9.firebaseapp.com",
  projectId: "theta-b3cb9",
  storageBucket: "theta-b3cb9.firebasestorage.app",
  messagingSenderId: "691805889339",
  appId: "1:691805889339:web:116885eaee646d5a1e8d1e",
  measurementId: "G-ZC88PCY2NN",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Function to log UTM parameters
export const logUtmParameters = (utmSource, utmMedium, utmCampaign) => {
  logEvent(analytics, "utm_tracking", {
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
  });
};

export { db, auth, analytics };
